import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent {

  safeSrc: SafeResourceUrl | undefined;
thumbnail: any;

constructor(private sanitizer: DomSanitizer) { 
  this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/UGnOE_EMw-E?rel=0");

}

  isUIVisible: boolean = false; 
  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  showVideo () {
    this.isUIVisible = !this.isUIVisible;
  }
}
